import { render, staticRenderFns } from "./zsmanage.vue?vue&type=template&id=450d106c&scoped=true"
import script from "./zsmanage.vue?vue&type=script&lang=js"
export * from "./zsmanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d106c",
  null
  
)

export default component.exports